import React from 'react'

function MyAds() {
    return (
        <section class="ads">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="ads__wrapper">
              <div class="ads__title">
                Мои объявления
              </div>
              <div class="ads__sp">
                <div class="ads-sp__soc d-flex">
                  <div class="price-search__item search-item">
                    <div class="search-item__title">
                      Социальная сеть
                    </div>
                    <div class="dropdown wsto">
                      <button class="search-item__vp1 text-align searchwidth">
                        Социальная сеть
                        <div class="dropdown-child stylesdc">
                          <a href="#">Подраздел 1</a>
                          <a href="#">Подраздел 2</a>
                          <a href="#">Подраздел 3</a>
                          <a href="#">Подраздел 4</a>
                          <a href="#">Подраздел 5</a>
                        </div>
                      </button>
                    </div>
                  </div>
                  <div class="sp-soc__ft">
                    <div class="search-item__title">
                      Период
                    </div>
                    <form action="#" class="ads__form">
                      <input type="text" placeholder="С" class="from" />
                      <input type="text" placeholder="По" class="to" />
                    </form>
                  </div>
                  <div class="sp-soc__search">
                    <form action="#" class="form-search">
                      <div class="form-search-box">
                        <input type="text" class="search" placeholder="Поиск" />
                        <div class="search__img">
                          <img
                            src="img/search.svg"
                            alt="search"
                            class="search__icon"
                          />
                        </div>
                      </div>
                    </form>
                    <div class="form-search__drop">
                      Сбросить фильтр
                    </div>
                  </div>
                </div>
              </div>
              <div class="ads__subtitle">
                <p>
                  В связи с большим количеством объявлений, публикуемых на сайте
                  каждый день, сообщения могут быстро уйти из виду у
                  потенциального покупателя. Вы можете поднять свои объявления
                  вверх бесплатно один раз в пять дней, нажав на соответствующую
                  иконку!
                </p>
                <p>
                  PRO аккаунт позволяет поднимать объявления один раз в два дня,
                  таким образом вероятность продажи вашей группы сильно
                  возрастает. <a href="#">Купить PRO аккаунт!</a>
                </p>
                <p>
                  Также вы можете воспользоваться платными услугами закрепления
                  объявления или выделения его цветом. В этом случае ваши
                  объявления всегда будут выше простых объявлений. Продавайте
                  ваши группы быстрее. <a href="#">Подробнее</a>
                </p>
              </div>
              <div class="ads__act d-flex">
                <div class="ads-act__text">Акутальные</div>
                <div class="ads-act__text">Архив</div>
              </div>
              <div class="act__btn">
                <a href="#">У вас нет объявлений но вы можете создать его.</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    )
}

export default MyAds
